/**
 * actions
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */

import { REFRESH_USER_SHOP_INFO, REFRESH_USER_PHONE_INFO, REFRESH_USER_INFO } from './types'
import { getUserShopInfo, getUserPhoneInfo } from '../../api/userInfoApi'
import { truckBaseUrl } from '@/api/urlConfig'
import axios from '@/api/createApi'

export const actions = {
  /**
   * 刷新用户积分商城信息
   * @param state
   * @param commit
   * @param param
   */
  refresh_user_shop_info ({ commit }) {
    getUserShopInfo().then(res => {
      if (res.isSuccess) {
        commit(REFRESH_USER_SHOP_INFO, res)
      }
    })
  },

  /**
   *
   * 获取用户的电话号码
   * @param {*} { commit}
   * @param {*} entrance
   */
  async refresh_user_phone_info ({ commit, state}) {
    const { entranceAppname } = state
    const response = await getUserPhoneInfo({entrance: entranceAppname})
    if (response.isSuccess) {
      commit(REFRESH_USER_PHONE_INFO, response)
    }
    // getUserPhoneInfo({isIos}).then(res => {
    //   if (res.isSuccess) {
    //     commit(REFRESH_USER_PHONE_INFO, res)
    //   }
    // })
  },

  /**
   * 获取用户信息
   * @param {*} param
   */
  async refresh_user_info ({ commit }) {
    try {
      const { code, content } = await axios({
        url: 'adapter/person/getUserInfo',
        baseURL: process.env.VUE_APP_TRUCK_BASE_URL
      })
      if (code === 200) {
        commit(REFRESH_USER_INFO, content)
      }
    } catch (error) {
      // 错误信息
    }
    // getUserId().then(res => {
    //   console.log(res)
    //   if (res.isSuccess) {
    //     console.log(res)
    //   }
    // })
  },

  /**
   *
   *
   * 获取用户的常用省份
  */
  async getUserOftenProvince ({ commit }) {
    try {
      const { code, data } = await axios({
        url: `${truckBaseUrl}/location/oftenProvince/USER`,
        baseURL: process.env.VUE_APP_API
      })
      if (code === 10000) {
        commit('updateUserInfoState', { key: 'recentlyUser', value: data })
      }
    } catch (error) {
      // 错误信息
    }
  }
}
